import { useCallback } from 'react';

import { callPost } from '@/api/fetcher';
import type { ApiError } from '@/shared/types/api';
import type { AuthoringValidationResult } from '@/shared/types/authoring-validation';

export type ValidateOutcome =
  { kind: 'ok'; result: AuthoringValidationResult } | { kind: 'degraded' };

interface UseValidateDraftOptions {
  endpoint: string;
}

export const useValidateDraft = <T>({ endpoint }: UseValidateDraftOptions) => {
  const validate = useCallback(
    async (body: T, prevRecommendation?: string): Promise<ValidateOutcome> => {
      try {
        const payload: Record<string, unknown> = { ...(body as Record<string, unknown>) };
        if (prevRecommendation) {
          payload.prev_recommendation = prevRecommendation;
        }
        const result = (await callPost(endpoint, payload)) as AuthoringValidationResult;
        return { kind: 'ok', result };
      } catch (err) {
        const status = (err as ApiError | null)?.statusCode;
        console.warn('Authoring validator degraded', { endpoint, status });
        return { kind: 'degraded' };
      }
    },
    [endpoint]
  );

  return { validate };
};
